<template>
  <div>
    <v-skeleton-loader
      v-if="ttMarcas.length === 0"
      fade-transition
      height="94"
      type="list-item-three-line"
    >
    </v-skeleton-loader>
    <div v-else>
      <v-list dense>
        <template>
          <v-list-item
            v-for="(item, j) in  subCatMarcas(marcasItem)"
            :key="`${j}-${item.Marca}`"
          >
            <v-list-item-content>
              <v-checkbox
                v-model="selectedFilterMarca"
                :value="item.Marca"
                @click="itemmarca(selectedFilterMarca)"
                color="#B05954"
                class="my-n2"
                :ripple="false"
                hide-details
                :disabled="filterconsolidado.length === 0 || subCatMarcas(marcasItem).length===1"
                dense
                
              >
                <template v-slot:label>
                  <div class="body-2">
                    {{ item.NombreMarca }}
                  </div>
                </template>
              </v-checkbox>
            </v-list-item-content>
          </v-list-item>

        </template>
      </v-list>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
  name: "listaMarca",
  data() {
    return {
      checkMarca: [],
    };
  },

  watch: {
    $route(to, from) {
      this.checkMarca = [];
    },
  },
  props: {
    nitems: Number,

    tammarca: Number,
    tamsubcat: Number,
    filterdata: Object,
  },
  methods: {
    ...mapMutations(["GET_BUSCARMARCA", "CLR_BUSCARMARCA", "clr_page"]),
    limpiaMarca() {
      this.checkMarca = [];
      this.CLR_BUSCARMARCA();
    },
    itemmarca(valor) {
      this.clr_page()
      this.GET_BUSCARMARCA(valor);
    },
  },
  computed: {
    ...mapGetters(["filtermarca", "filterconsolidado"]),

    ...mapState([
      "ttArticuloAll",
      "marcaidsel",
      "changeSubcat",
      "filter",
      "ttMarcas",
      "SubCategorias",
    ]),
    selectedFilterMarca: {
      get() {
        return this.filter.codmarca;
      },
      set(valor) {
        this.GET_BUSCARMARCA(valor);
      },
    },
    subCatMarcas: function () {
      return function (items) {
        const uniqueMarcas = Array.from(
          new Set(items.map((marca) => marca.Marca))
        ).map((Marca) => {
          return items.find((marca) => marca.Marca === Marca);
        });

        return uniqueMarcas;
      };
    },
    marcasItem: function () {
        //
        let uniqueArray = [];

        if (this.ttArticuloAll) {
          uniqueArray = [
            ...new Set(
              this.ttArticuloAll
                .filter((x) => x.SubCategoria === this.filter.codscat)
                .map((x) => ({
                  Marca: x.Marca,
                  NombreMarca: x.NombreMarca,
                }))
            ),
          ];
        
          return uniqueArray.sort((a, b) => a.NombreMarca.localeCompare(b.NombreMarca));
        }
      },
   

  },
};
</script>

<style scoped>
.label-checkbox {
  font-size: 1.5rem;
}
</style>
